import { strFromU8 } from "fflate";
import SWFUnpacker from "./container/swf/SWFUnpacker";
import ZIPUnpacker from "./container/ZIPUnpacker";
export default class FileLoader {
    constructor() {
        this.textFiles = [".sm", ".ssc", ".qua", ".osu", ".txt"];
        this._urls = [];
        this._count = 0;
        this.files = [];
        /**
         * Load data from URL into file list.
         */
        this.loadFromURL = (url, format) => {
            return new Promise((resolve, reject) => {
                // Don't reload urls.
                if (this._urls.indexOf(url) != -1) {
                    return resolve(this);
                }
                this._urls.push(url);
                fetch(url)
                    .then(response => response.arrayBuffer())
                    .then(async (buffer) => {
                    await this.bufferUnpacker(format, buffer);
                }).then(() => {
                    return resolve(this);
                });
            });
        };
        this.loadFromFileList = (files) => {
            return new Promise(async (resolve, reject) => {
                for (let file of files) {
                    await this.readFile(file);
                }
                resolve(true);
            });
        };
        this.loadFromFile = (file) => {
        };
        this.findEntry = (ending, exactMatch = false) => {
            return new Promise((resolve, reject) => {
                let file = this.findEntrySync(ending, exactMatch);
                if (file != null) {
                    resolve(file);
                }
                reject(`Couldn't find: ${ending}`);
            });
        };
        this.findEntrySync = (ending, exactMatch = false) => {
            if (ending == null || this.files == null) {
                return null;
            }
            for (let i = 0; i < this.files.length; i++) {
                let { path } = this.files[i];
                if (!exactMatch && path.endsWith(ending)) {
                    return this.files[i];
                }
                else if (exactMatch && path == ending) {
                    return this.files[i];
                }
            }
            return null;
        };
        /*
            onLoadComplete(data: ArrayBuffer) {
                if (this.options == null) {
                    return;
                }
    
                let parse_start = performance.now();
                this.parser = this.getContainerHandler(this.options, data);
                console.log(`Parse Time:`, (performance.now() - parse_start));
                console.log('parser', this.parser);
    
                let blob: Blob = new Blob([this.parser.audio], { type: 'audio/mpeg' });
                let blobUrl = URL.createObjectURL(blob);
    
                document.getElementById('source').setAttribute('src', blobUrl);
    
                let audioElm: HTMLAudioElement = document.getElementById('audio') as HTMLAudioElement;
                audioElm.pause();
                audioElm.load();
            }
            */
    }
    readFile(file) {
        return new Promise((resolve, reject) => {
            var fr = new FileReader();
            fr.onload = () => {
                let filePath = file.filepath ?? file.name;
                let fileData = fr.result;
                // Parse text files into strings.
                let fileExtension = filePath.substring(filePath.lastIndexOf("."));
                let hasExtension = fileExtension.indexOf(".") >= 0;
                if (hasExtension && this.textFiles.indexOf(fileExtension) !== -1) {
                    fileData = strFromU8(fileData);
                }
                //console.log(filePath)
                this.files.push({
                    name: file.name,
                    dir: file.filepath ? file.filepath.substr(0, file.filepath.length - file.name.length) : "",
                    path: filePath,
                    data: fileData
                });
                //console.log(this.files);
                resolve(true);
            };
            fr.onerror = reject;
            fr.readAsArrayBuffer(file);
        });
    }
    bufferUnpacker(format, buffer) {
        return new Promise(async (resolve, reject) => {
            switch (format) {
                case 'zip':
                    await ZIPUnpacker.parse(this.files, buffer, `${this._count++}/`);
                    resolve(true);
                    break;
                case 'swf':
                    await SWFUnpacker.parse(this.files, buffer, `${this._count++}/`);
                    resolve(true);
                    break;
                default:
                    console.error("Unknown format for container.", format);
                    reject();
                    break;
            }
        });
    }
}
